import {
    color_grey_dark,
    color_grey_light,
    color_red_default,
    color_red_light,
    color_white,
} from "../../../../constants/colors";

export const styles = {
  weeklyTaskRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 15,
    paddingTop: 15,
    paddingBottom: 15,
    borderBottom: `1px solid ${color_grey_light}`,
  },
  completedWeeklyTaskRow: {
    borderBottom: `1px solid ${color_grey_light}`,
  },
  lastWeeklyTaskRow: {
    borderBottom: "none",
  },
  weeklyTaskCircle: {
    width: 20,
    minWidth: 20,
    height: 20,
    minHeight: 20,
    borderRadius: "50%",
    backgroundColor: color_white,
    border: `1px solid ${color_red_light}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: color_white,
    boxSizing: "border-box",
  },
  completedWeeklyTaskCircle: {
    backgroundColor: color_white,
    border: `1px solid ${color_grey_light}`,
    color: color_grey_dark,
  },
  completedWeeklyTaskText: {
    color: color_grey_dark,
    textDecoration: "line-through",
  },
  weeklyTasksContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  weeklyTasksHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 8,
  },
  weeklyTasksTitleGroup: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    minWidth: 0,
  },
  weeklyTasksProgress: {
    flexShrink: 0,
    borderRadius: 999,
    backgroundColor: "#FFF1F1",
    color: color_red_default,
    fontFamily: "Onest",
    fontSize: 12,
    fontWeight: 600,
    lineHeight: "16px",
    padding: "2px 8px",
  },
  weeklyTasksEditButton: {
    flexShrink: 0,
    width: 32,
    height: 32,
    borderRadius: "50%",
    backgroundColor: "#FFF1F1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  weeklyTasksRowContainer: {
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    height: "100%",
  },
};
